<div class="plm-page">
  <header class="plm-header">
    <div>
      <h1>Pavement / chainage progress</h1>
      <p>Earthwork through painting (including shoulder), by segment, subsegment, or LRS span. Quantities in project UTM (default EPSG:32644).</p>
    </div>
    <button mat-stroked-button color="primary" (click)="seed()">Seed from road_project segments</button>
  </header>

  <div class="plm-toolbar">
    <mat-form-field appearance="outline">
      <mat-label>Project</mat-label>
      <mat-select [(ngModel)]="projectId" (selectionChange)="onProject()">
        <mat-option [value]="null">All</mat-option>
        <mat-option *ngFor="let p of projects" [value]="p.id">{{ p.project_name || p.project_identifier || p.id }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <mat-tab-group>
    <mat-tab label="Work locations">
      <div class="plm-card">
        <form class="plm-form" (ngSubmit)="addLocation()">
          <mat-form-field appearance="outline">
            <mat-label>Kind</mat-label>
            <mat-select [(ngModel)]="locForm.location_kind" name="kind">
              <mat-option value="segment">Segment</mat-option>
              <mat-option value="subsegment">Subsegment</mat-option>
              <mat-option value="lrs_span">LRS span</mat-option>
              <mat-option value="channel">Channel</mat-option>
              <mat-option value="furniture">Furniture</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput [(ngModel)]="locForm.location_name" name="locName" required />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>From m</mat-label>
            <input matInput type="number" [(ngModel)]="locForm.from_measure_m" name="from" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>To m</mat-label>
            <input matInput type="number" [(ngModel)]="locForm.to_measure_m" name="to" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>LRS route id</mat-label>
            <input matInput type="number" [(ngModel)]="locForm.lrs_route_id" name="route" />
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit">Add location</button>
        </form>
        <table mat-table [dataSource]="locations">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Location</th>
            <td mat-cell *matCellDef="let row">
              <div>{{ row.location_name || row.location_code }}</div>
              <div class="cell-sub">{{ row.location_kind }}</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="ch">
            <th mat-header-cell *matHeaderCellDef>Chainage</th>
            <td mat-cell *matCellDef="let row">{{ chainage(row) }}</td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['name','ch']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['name','ch']"></tr>
        </table>
        <p *ngIf="!locations.length" class="empty-msg">No work locations yet.</p>
      </div>
    </mat-tab>

    <mat-tab label="Pavement layers">
      <div class="plm-card">
        <form class="plm-form" (ngSubmit)="addWork()">
          <mat-form-field appearance="outline">
            <mat-label>Location</mat-label>
            <mat-select [(ngModel)]="workForm.work_location_id" name="wl" required>
              <mat-option *ngFor="let l of locations" [value]="l.id">{{ l.location_name || l.location_code || l.id }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Layer</mat-label>
            <mat-select [(ngModel)]="workForm.layer_id" name="layer" required>
              <mat-option *ngFor="let c of catalog" [value]="c.id">{{ c.label }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Side</mat-label>
            <mat-select [(ngModel)]="workForm.side" name="side">
              <mat-option value="full">Full</mat-option>
              <mat-option value="LHS">LHS</mat-option>
              <mat-option value="RHS">RHS</mat-option>
              <mat-option value="median">Median</mat-option>
              <mat-option value="shoulder">Shoulder</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Planned qty</mat-label>
            <input matInput type="number" [(ngModel)]="workForm.planned_qty" name="pq" />
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit">Add work item</button>
        </form>
        <table mat-table [dataSource]="workItems">
          <ng-container matColumnDef="loc">
            <th mat-header-cell *matHeaderCellDef>Location</th>
            <td mat-cell *matCellDef="let row">{{ row.location_name }} <span class="cell-sub">{{ chainage(row) }}</span></td>
          </ng-container>
          <ng-container matColumnDef="layer">
            <th mat-header-cell *matHeaderCellDef>Layer</th>
            <td mat-cell *matCellDef="let row">{{ row.layer_label }} ({{ row.side }})</td>
          </ng-container>
          <ng-container matColumnDef="qty">
            <th mat-header-cell *matHeaderCellDef>Qty</th>
            <td mat-cell *matCellDef="let row" class="pct">{{ row.actual_qty || 0 }} / {{ row.planned_qty || '—' }} {{ row.uom }}</td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let row">
              <span class="status-pill" [ngClass]="'status-' + row.status">{{ row.status }}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="act">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <button mat-button (click)="setStatus(row, 'in_progress')">Start</button>
              <button mat-button color="primary" (click)="setStatus(row, 'completed')">Complete</button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['loc','layer','qty','status','act']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['loc','layer','qty','status','act']"></tr>
        </table>
        <p *ngIf="!workItems.length" class="empty-msg">No pavement work items.</p>
      </div>
    </mat-tab>

    <mat-tab label="Toll / bays / WIM / channel">
      <div class="plm-card">
        <form class="plm-form" (ngSubmit)="addFurniture()">
          <mat-form-field appearance="outline">
            <mat-label>Asset type</mat-label>
            <mat-select [(ngModel)]="furnitureKind" name="fk" (selectionChange)="loadFurniture()">
              <mat-option *ngFor="let k of kinds" [value]="k.id">{{ k.label }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Code</mat-label>
            <input matInput [(ngModel)]="furnForm.code" name="fc" required />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Name</mat-label>
            <input matInput [(ngModel)]="furnForm.name" name="fn" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>From m</mat-label>
            <input matInput type="number" [(ngModel)]="furnForm.from_measure_m" name="ff" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>To m</mat-label>
            <input matInput type="number" [(ngModel)]="furnForm.to_measure_m" name="ft" />
          </mat-form-field>
          <button mat-raised-button color="primary" type="submit">Add asset</button>
        </form>
        <table mat-table [dataSource]="furniture">
          <ng-container matColumnDef="code">
            <th mat-header-cell *matHeaderCellDef>Code</th>
            <td mat-cell *matCellDef="let row">{{ row.plaza_code || row.bay_code || row.station_code || row.facility_code || row.channel_code }}</td>
          </ng-container>
          <ng-container matColumnDef="nm">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let row">{{ row.plaza_name || row.bay_name || row.station_name || row.facility_name || row.channel_name }}</td>
          </ng-container>
          <ng-container matColumnDef="st">
            <th mat-header-cell *matHeaderCellDef>Construction</th>
            <td mat-cell *matCellDef="let row">
              <span class="status-pill" [ngClass]="'status-' + row.construction_status">{{ row.construction_status }} ({{ row.pct_complete }}%)</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="act">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <button mat-button (click)="bumpFurniture(row, 'in_progress')">Start</button>
              <button mat-button color="primary" (click)="bumpFurniture(row, 'completed')">Complete</button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="['code','nm','st','act']"></tr>
          <tr mat-row *matRowDef="let row; columns: ['code','nm','st','act']"></tr>
        </table>
        <p *ngIf="!furniture.length" class="empty-msg">No roadside assets of this type.</p>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
